import Header from "@commons/header";
import Column from "@components/column";
import React from "react";
import { useLocation, useParams } from "react-router-dom";
import BackButton from "@components/backButton";
import Tab from "@components/tabs";
import Overview from "./overview";
import OrderList from "./orders";
import CustomerTransactions from "./transactions";
import Referrals from "./referrals";
import LoyaltyPoints from "./loyalty-points";

const IndividualCustomer = () => {
  const { state } = useLocation();
  const { id } = useParams();
  const customerId = state?.id || Number(id);

  const tabs: any = [
    { label: "Overview", component: Overview, props: { state, customerId } },
    {
      label: "Transactions",
      component: CustomerTransactions,
      props: { state, customerId },
    },
    { label: "Order List", component: OrderList, props: { state, customerId } },
    { label: "Referrals", component: Referrals, props: { state, customerId } },
    { label: "Loyalty Points", component: LoyaltyPoints, props: { state, customerId } },
  ];
  return (
    <Column>
      <BackButton path={`/admin/users/customer/customer-lists`} />
      <Tab items={tabs} />
    </Column>
  );
};

export default IndividualCustomer;
